<div
    aria-live="assertive"
    class="context-toast --{{ type }} --{{ animation }}"
    [attr.role]="type === 'error' ? 'alert' : 'status'"
    (mouseenter)="pause()"
    (mouseleave)="resume()"
>
    @if (type === "error") {
        <mat-icon class="context-toast__icon" svgIcon="app:error"></mat-icon>
    }
    <span class="context-toast__content">{{ title }}</span>
    @if (action) {
        <button class="context-toast__action" type="button" (click)="runAction()">{{ action.label }}</button>
    }
    <button class="context-toast__close" type="button" [attr.aria-label]="'TOAST.close' | translate" (click)="close()">
        <mat-icon svgIcon="app:close"></mat-icon>
    </button>
</div>
